import { AppServerAPI } from '@sdbn/common';
import { Component, OnInit } from '@angular/core';
import { ContextChange } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

const MODE_DAILY = 'dialy';
const MODE_HOURLY = 'hourly';

@Component({
    selector: 'app-report-station-occupancy-dashboard',
    templateUrl: './station-occupancy-dashboard.component.html',
    styleUrls: ['./station-occupancy-dashboard.component.scss'],
    standalone: false
})
export class StationOccupancyDashboardComponent extends AbstractWidgetComponent implements OnInit {

  private selectedMode = MODE_DAILY;

  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  hourlyOccupancyUrl: string;

  selectedDate = new Date();
  data: any;

  constructor(
    private appServerAPI: AppServerAPI) {
    super();
  }

  ngOnInit() {
    this.loadReport();
  }

  public back() {
    this.selectedDate = new Date(this.selectedDate.getTime() - this.ONE_DAY_DURATION);
    this.loadReport();
  }

  public forward() {
    this.selectedDate = new Date(this.selectedDate.getTime() + this.ONE_DAY_DURATION);
    this.loadReport();
  }

  private loadReport() {

    this.data = null;
    const period = this.isShowDailyMode() ? 'day' : this.isShowHourlyMode ? 'hours' : 'day';

    this.appServerAPI.execute(`/client/control/reporting/stationoccupancy`, { date: this.selectedDate, period })
      .subscribe(
        response => {
          this.data = response;
        }
      );

  }

  public isModeSelected(mode: string): boolean {
    return this.selectedMode === mode;
  }

  public showDailyMode() {
    this.selectedMode = MODE_DAILY;
    this.loadReport();
  }

  public isShowDailyMode(): boolean {
    return this.selectedMode === MODE_DAILY;
  }

  public showHourlyMode() {
    this.selectedMode = MODE_HOURLY;
    this.loadReport();
  }

  public isShowHourlyMode(): boolean {
    return this.selectedMode === MODE_HOURLY;
  }

  public printHourlyReport() {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'listexcel');

    // keep focus in current window
    window.focus();

    const url = `/client/control/reporting/print-stationoccupancy-hourly`;

    this.appServerAPI.postWithArraybufferResponse<any>(url, this.selectedDate).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  onContextChange(contextChange: ContextChange) {
  }
  onSetElementAndContext() {
  }
}
